import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SpectraBusApp } from '@spectrabus/ui';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('SpectraBus application root was not found.');
}

createRoot(root).render(
  <StrictMode>
    <SpectraBusApp mode="receiver" />
  </StrictMode>,
);

declare const __SPECTRABUS_BUILD__: string;

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // The build identifier in the registration URL gives every deployment a
    // fresh worker URL, so browsers pick up the new offline shell without a
    // manually bumped cache version.
    void navigator.serviceWorker
      .register(`/sw.js?v=${__SPECTRABUS_BUILD__}`)
      .catch((error: unknown) => {
        console.error('SpectraBus offline shell registration failed.', error);
      });
  });
}
